<template>
  <el-form
    v-loading.fullscreen.lock="fullscreenLoading"
    ref="formNote"
    :model="model"
    :rules="rules"
    label-position="top"
    class="padding-20"
    @submit.native.prevent="onSubmit">
    <el-row>
      <el-col :span="24">
        <el-form-item
          label="Título de la Nota"
          prop="title">
          <el-input v-model="model.title"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item
          label="Contenido"
          prop="content">
          <el-input
            v-model="model.content"
            :rows="4"
            resize="none"
            type="textarea"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item
          label="Asignar a una oportunidad"
          prop="oportunity">
          <el-select
            v-model="model.oportunity"
            placeholder="Elija una oportunidad"
            style="width: 100%">
            <el-option
              v-for="(oportunity, index) in opportunities"
              :key="index"
              :label="oportunity.title"
              :value="oportunity.id"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button
          type="primary"
          native-type="submit">
          Guardar
        </el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import notesModel from '@/models/notes/notes-model'
import {mapActions} from 'vuex'
import http from '@/services/http.service'

export default {
  name: 'CustomersCreateNotes',
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      model: notesModel.model(),
      rules: notesModel.rules(),
      opportunities: []
    }
  },
  mounted () {
    if (this.customer && this.customer.id) {
      http
        .get(process.env.API_URL + 'opportunities?filters[where][customerId][eq]=' + parseInt(this.customer.id))
        .then(response => {
          this.opportunities = response.data.items
        }).catch(error => {
          return Promise.reject(error)
        })
    }
  },
  methods: {
    ...mapActions('notes', ['save']),
    onSubmit () {
      this.$refs['formNote'].validate((valid) => {
        this.model.customerId = this.customer.id
        if (valid) {
          this.save(this.model).then(response => {
            this.$notify.success({
              group: 'app',
              title: 'Nota creada.',
              message: 'La nota se creo correctamente'
            })
            this.$store.dispatch('notes/query', {
              'filters[where][customerId][eq]': this.customer.id
            }).then(({data}) => {
              this.$store.dispatch('app/toggleNotesPanel')
            })
          }).catch(error => {
            this.$notify.error({
              group: 'app',
              title: 'Error al crear la tarea.',
              message: 'Por favor, vuelve a intentarlo.'
            })
            return Promise.reject(error)
          })
        } else {
          this.$notify.error({
            group: 'app',
            title: 'Verifica el formulario.',
            message: 'Por favor, revisa los errores que se indican dentro del formulario.'
          })
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-button {
  background-color: $primary;
  color: #ffffff;
  width: 100%;
  box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/modules/notes/note-form.vue